module.exports = __webpack_public_path__ + "static/media/Location_Book-Page43.96feab6d.png";